import { getDefaultPreviewImage } from './config';
import { IFrameRequest } from './types';
import uploader from './uploader';

export async function getFilePreviewUrl(
  file: File | Blob,
  fileName: string,
  localPreview?: string
): Promise<string> {
  const defaultPreviewImage = getDefaultPreviewImage();

  if (file.type.indexOf('video') === 0) {
    try {
      let thumbnailBlob: Blob;
      let previewMimeType = '';

      if (localPreview) {
        previewMimeType = 'image/png';
        thumbnailBlob = uploader.dataURItoBlob(localPreview, { type: previewMimeType });
      } else {
        const { thumbnail } = await getFirstVideoFrameAndDuration(file, 800, 600);
        previewMimeType = 'image/jpeg';
        thumbnailBlob = uploader.dataURItoBlob(thumbnail, { type: previewMimeType });
      }

      const previewFileName = `thumbnail-${fileName}`;
      const result = await uploader.uploadFileWithUrl(
        thumbnailBlob,
        previewFileName,
        previewMimeType
      );

      return result.publicUrl;
    } catch {
      return defaultPreviewImage;
    }
  }
  return defaultPreviewImage;
}

export async function getFirstVideoFrameAndDuration(
  videoFile: File | Blob,
  maxWidth?: number,
  maxHeight?: number
): Promise<IFrameRequest> {
  return new Promise((resolve, reject) => {
    const url = window.URL.createObjectURL(videoFile);
    const video = document.createElement('video');

    video.onerror = reject;
    video.oncanplay = (): void => {
      video.oncanplay = null;
      video.currentTime = 0.01;
    };
    video.onseeked = (): void => {
      const { videoWidth, videoHeight } = video;
      if (videoWidth === 0 || videoHeight === 0) {
        reject(new Error('Invalid video dimensions'));
        return;
      }
      let sizeQ = 1;
      if (maxWidth && maxHeight) {
        sizeQ = Math.max(videoWidth / maxWidth, videoHeight / maxHeight, 1);
      }
      const endWidth = videoWidth / sizeQ;
      const endHeight = videoHeight / sizeQ;
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      canvas.width = endWidth;
      canvas.height = endHeight;

      ctx?.drawImage(video, 0, 0, endWidth, endHeight);
      resolve({
        thumbnail: canvas.toDataURL('image/jpeg', 0.8),
        width: endWidth,
        height: endHeight,
        duration: video.duration,
      });
      video.src = '';
      window.URL.revokeObjectURL(url);
    };
    video.src = url;
  });
}

export const previewBuilder = {
  getFilePreviewUrl,
  getFirstVideoFrameAndDuration,
};
